/* Scroll reveal for The Signature launch sections.
 *
 * Self-contained on purpose: the theme's global animations_reveal_on_scroll
 * setting is off, so animations.js is never loaded (layout/theme.liquid) while
 * base.css still sets opacity: 0.01 on Dawn's .scroll-trigger classes. Reusing
 * those classes here would hide the launch content permanently.
 *
 * Elements are hidden only after this script arms them, so with JS disabled the
 * launch renders fully visible.
 */
(function () {
  if (window.__signatureRevealInit) return;
  window.__signatureRevealInit = true;

  var ARMED = 'signature-reveal--armed';
  var VISIBLE = 'signature-reveal--in';

  function revealAll(root) {
    root.querySelectorAll('[data-signature-reveal]').forEach(function (el) {
      el.classList.add(ARMED, VISIBLE);
    });
  }

  function init() {
    var supported =
      'IntersectionObserver' in window &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var observer = supported
      ? new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add(VISIBLE);
              obs.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
        )
      : null;

    function arm(root) {
      if (!observer) {
        revealAll(root);
        return;
      }

      root.querySelectorAll('[data-signature-reveal]').forEach(function (el) {
        if (el.classList.contains(ARMED)) return;

        // Anything already on screen is left alone. This script is deferred, so
        // the browser may already have painted it; hiding it now would flash the
        // hero out and back in.
        if (el.getBoundingClientRect().top < window.innerHeight) {
          el.classList.add(ARMED, VISIBLE);
          return;
        }

        el.classList.add(ARMED);
        observer.observe(el);
      });
    }

    document.querySelectorAll('[data-signature-reveal-root]').forEach(arm);

    // In the theme editor a re-rendered section should appear immediately.
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-signature-reveal-root]').forEach(revealAll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
